<template>
  <a class="contract-item" :href="url">
    <div class="title">{{ companyName }}</div>
    <div>文件名: {{ documentFileName }}</div>
    <div>申报月份: {{ month.substring(0,7) }}</div>
    <!--    <div>创建日期: {{ cDate }}</div>-->
    <!--    <div>更新日期: {{ uDate }}</div>-->
  </a>
</template>

<script>

  export default {
    name: "ContractItem",
    computed: {
      // cDate(){
      //   return dateFormat(new Date(this.createDate+''), "YYYY-MM-DD");
      // },
      // uDate(){
      //   return dateFormat(new Date(this.lastUpdateDate+''), "YYYY-MM-DD");
      // }
      url() {
        let type = '';
        let index = this.documentFileName.lastIndexOf(".");
        let suffix = this.documentFileName.substr(index + 1);

        if (suffix === 'jpg' || suffix === 'jpeg') {
          type = 'image';
        } else if (suffix === 'xls' || suffix === 'xlsx') {
          type = 'excel'
        } else if (suffix === 'pdf') {
          type = 'pdf';
        }
        //return `/preview.html?id=${this.documentInternalName}&isPic=${isPic}`;
        return `/preview.html?type=${type}&url=${process.env.VUE_APP_API}assets/${this.documentInternalName}`;
      }
    },
    props: {
      month: {
        type: String,
        required: true
      },
      documentFileName: {
        type: String,
        required: true
      },
      createDate: {
        type: String,
        required: true
      },
      lastUpdateDate: {
        type: String,
        default: ''
      },
      companyName: {
        type: String,
        required: true
      },
      documentInternalName: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped>
  .contract-item {
    border-bottom: 1px solid #D8D8D8;
    padding: 10px 14px;
    font-size: 14px;
    color: #9A9A9A;
    line-height: 24px;
    position: relative;
    text-decoration: none;
    display: block;
  }

  .contract-item .title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
  }

  .contract-item .currency {
    color: #FD493A;
    font-size: 16px;
  }

  .contract-item .type {
    position: absolute;
    right: 14px;
    bottom: 10px;
  }

  .contract-item .type.type0 {
    /*正式*/
    color: #FD493A;
  }

  .contract-item .type.type1 {
    /*意向*/
    color: #F2A138;
  }

  .contract-item .type.type2 {
    /*已签*/
    color: #21B811;
  }

  .contract-item .type.type3 {
    /*续约*/
    color: #0090FF;
  }
</style>
